import { POST_PIN_PERMISSIONS } from './NewsboardPostHeaderPinAction.constants'

export function getActionPermission(pinned, permissions) {
  if (!permissions) {
    return false
  }

  if (pinned) {
    return permissions[POST_PIN_PERMISSIONS.unpin]
  }

  return permissions[POST_PIN_PERMISSIONS.pin]
}
